import { Box, Stack } from "@mantine/core";
import style from "./privacy.module.css";
import { Link } from "react-router-dom";
import { PrivacyMenu } from "./privacy-menu";
import { useTranslation } from "react-i18next";

export const TermsOfServicePage = () => {
    const { t } = useTranslation(['privacy']);
    
    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.contentWrapper}>
                    <Stack className={style.menuContent} spacing={"0.5rem"} mt={"10rem"}>
                        <PrivacyMenu />
                    </Stack>

                    <Box className={style.textContent} spacing={"0.5rem"} mt={"8rem"}>
                        <article>
                            <h1 className={style.header1}>{t("terms.title")}</h1>

                            <p>{t("terms.thanks")}</p>
                            <br />
                            <p>
                                {t("terms.introduction")}
                                <Link className={style.linkInline} to="/privacy-policy">
                                    {t("terms.privacyPolicy")}
                                </Link>{" "}
                                {t("terms.introductionEnd")}
                            </p>

                            <br />
                            <h2 className={style.header2}>{t("terms.section1.title")}</h2>
                            <p>{t("terms.section1.content")}</p>

                            <br />
                            <h2 className={style.header2}>{t("terms.section2.title")}</h2>
                            <p>{t("terms.section2.contentA")}</p>
                            <br />
                            <p>{t("terms.section2.contentB")}</p>
                            <br />
                            <p>{t("terms.section2.contentC")}</p>
                            <br />
                            <p>{t("terms.section2.contentD")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section3.title")}</h2>
                            <p>{t("terms.section3.contentA")}</p>
                            <br />
                            <p>{t("terms.section3.contentB")}</p>
                            <br />
                            <p>{t("terms.section3.contentC")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section4.title")}</h2>
                            <p>{t("terms.section4.contentA")}</p>
                            <br />

                            <p>{t("terms.section4.contentB")}</p>
                            <br />

                            <p>{t("terms.section4.contentC")}</p>
                            <br />

                            <p>{t("terms.section4.contentD")}</p>
                            <br />

                            <p>{t("terms.section4.contentE")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section5.title")}</h2>
                            <p>{t("terms.section5.contentA")}</p>
                            <br />

                            <p>{t("terms.section5.contentB")}</p>
                            <br />

                            <p>{t("terms.section5.contentC")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section6.title")}</h2>
                            <p>{t("terms.section6.contentA")}</p>
                            <br />

                            <p>{t("terms.section6.contentB")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section7.title")}</h2>
                            <p>{t("terms.section7.contentA")}</p>
                            <br />

                            <p>{t("terms.section7.contentB")}</p>
                            <br />

                            <p>{t("terms.section7.contentC")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section8.title")}</h2>
                            <p>{t("terms.section8.intro")}</p>
                            <br />

                            <p>{t("terms.section8.contentA")}</p>
                            <br />

                            <p>
                                {t("terms.section8.contentB")}
                                <a className={style.linkInline} href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">
                                    https://ec.europa.eu/consumers/odr.
                                </a>
                            </p>
                            <br />

                            <p>{t("terms.section8.contentC")}</p>
                            <br />

                            <p>{t("terms.section8.contentD")}</p>
                            <br />

                            <p>{t("terms.section8.contentE")}</p>
                            <br />

                            <p>{t("terms.section8.contentH")}</p>
                            <br />

                            <h2 className={style.header2}>{t("terms.section9.title")}</h2>
                            <p>{t("terms.section9.contentA")}</p>
                            <br />

                            <p>{t("terms.section9.contentB")}</p>
                            <br />

                            <p>{t("terms.section9.contentC")}</p>
                            <br />

                            <p>{t("terms.section9.contentD")}</p>
                            <br />

                            <p>{t("terms.section9.contentE")}</p>
                            <br />

                            <p>{t("terms.section9.contentF")}</p>
                            <br />

                            <p>{t("terms.section9.contentG")}</p>
                            <br />

                            <p>{t("terms.section9.contentH")}</p>
                            <br />

                            <p>{t("terms.section9.contentI")}</p>
                            <br />

                            <p>{t("terms.section9.contentJ")}</p>
                            <br />
                        </article>
                    </Box>
                </div>
            </div>
        </div>
    );
};
